import { useEffect, useState, useContext, useRef } from "react";
import { petitions } from "../../../api/calls";
import { DataContext } from "../../../context/DataContext";
import { toast } from "sonner";
import { useForm } from "react-hook-form";
import Select from "react-select";
import Table from "../../componentsTable/TableProduct";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";
import TableLoad from "../../componentsTools/TableLoad";
import { exportToExcel_v1 } from "../../componentsTools/ExportToExcel";
import customStyles from "../../../frontend/styles/select";

export default function VerProducto() {
  const { session, idEmpresa } = useContext(DataContext);
  const [productos, setProductos] = useState([]);
  const [filtering, setFiltering] = useState("");
  const [estadoTabla, setEstadoTabla] = useState(false);
  const [idProducto, setIdProducto] = useState("");
  const [load, setLoad] = useState(true);

  const [tipo] = useState([
    {
      value: "P",
      label: "Producto",
    },
    {
      value: "S",
      label: "Servicio",
    },
    {
      value: "Q",
      label: "Paquete",
    },
  ]);

  const [categoria, setCategoria] = useState([]);
  const [medida, setMedida] = useState([]);
  const [marca, setMarca] = useState([]);
  const [modelo, setModelo] = useState([]);
  const [area, setArea] = useState([]);
  const [local, setLocal] = useState([]);
  const [TPServicio, setTPServicio] = useState([]);

  const modalRef = useRef(null);
  const modalRefFilter = useRef(null);

  const closeModal = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef.current);
    modalInstance.hide();
  };

  //DATOS
  const cantProducto = productos?.filter((p) => p.tipo === "P");
  const cantServicio = productos?.filter((p) => p.tipo === "S");
  const cantPaquete = productos?.filter((p) => p.tipo === "Q");
  const habilitado = productos?.filter((p) => p.estado === "S");
  const deshabilitado = productos?.filter((p) => p.estado === "N");

  const columns = [
    {
      header: "",
      accessorKey: "foto",
      className: "sort white-space-nowrap align-middle fs-10",
      width: "70px",
    },
    {
      header: "NOMBRE",
      accessorKey: "nombre",
      className: "sort white-space-nowrap align-middle ps-0",
      width: "350px",
    },
    {
      header: "PRECIO VENTA",
      accessorKey: "pventa",
      className: "sort white-space-nowrap align-middle ps-0",
      width: "350px",
    },
    {
      header: "PRECIO COMPRA",
      accessorKey: "pcompra",
      className: "sort white-space-nowrap align-middle ps-0",
      width: "350px",
    },
    {
      header: "CATEGORIA",
      accessorKey: "idCategoria",
      className: "sort white-space-nowrap align-middle ps-0",
      width: "350px",
    },
    {
      header: "TIPO",
      accessorKey: "tipo",
      className: "sort white-space-nowrap align-middle ps-0",
      width: "350px",
    },
    {
      header: "STOCK",
      accessorKey: "stock",
      className: "sort white-space-nowrap align-middle ps-0",
      width: "350px",
    },
    {
      header: "ESTADO",
      accessorKey: "estado",
      className: "sort white-space-nowrap align-middle ps-0",
      width: "350px",
    },
    {
      header: "ACCIONES",
      accessorKey: "acciones",
    },
  ];

  const form1 = useForm({
    defaultValues: {
      tipo: "P",
      kardex: false,
      pcompra: 0.0,
      pventa: 0.0,
      stock: 0.0,
      cicloConsumo: 0.0,
      dsct01: false,
      dsct02: 0.0,
    },
  });

  const form2 = useForm({
    defaultValues: {
      tipo: "",
      idCategoria: "",
      idTPServicio: "",
      estado: "",
    },
  });

  const filtrosActivos =
    !!form2.watch("tipo") ||
    !!form2.watch("idCategoria") ||
    !!form2.watch("idTPServicio") ||
    !!form2.watch("estado");

  const aplicarFiltros = form2.handleSubmit(() => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRefFilter.current);
    modalInstance.hide();
    setEstadoTabla(!estadoTabla);
  });

  useEffect(() => {
    const fetchProductos = async () => {
      setLoad(true);
      const response = await petitions.getProductos(
        idEmpresa(),
        session().token,
        {
          tipo: form2.watch("tipo") || "",
          idCategoria: form2.watch("idCategoria") || 0,
          idTPServicio: form2.watch("idTPServicio") || "",
          estado: form2.watch("estado") || "",
        }
      );
      if (response.status === "success") {
        setProductos(response.data);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
      setLoad(false);
    };

    fetchProductos();
  }, [estadoTabla, session, idEmpresa, form2]);

  const channel = (data) => {
    setIdProducto(data.idPServicio);
    form1.setValue("nombre", data.nombre, { shouldValidate: true });
    form1.setValue("obs", data.obs, { shouldValidate: true });
    form1.setValue("obs", data.obs, { shouldValidate: true });
    form1.setValue("pcompra", data.pcompra, { shouldValidate: true });
    form1.setValue("pventa", data.pventa, { shouldValidate: true });
    form1.setValue("tGarantia", data.tGarantia, { shouldValidate: true });
    form1.setValue("stock", data.stock, { shouldValidate: true });
    form1.setValue("cicloConsumo", data.cicloConsumo, { shouldValidate: true });
    form1.setValue("dsct02", data.dsct02, { shouldValidate: true });

    form1.setValue("kardex", data.kardex === "S" ? true : false);
    form1.setValue("dsct01", data.dsct01 === "S" ? true : false);

    form1.setValue("idCategoria", data.idCategoria, { shouldValidate: true });
    form1.setValue("tipo", data.tipo, { shouldValidate: true });
    form1.setValue("idMedida", data.idMedida, { shouldValidate: true });
    form1.setValue("idMedida", data.idMedida, { shouldValidate: true });
    form1.setValue("idMarca", data.idMarca, { shouldValidate: true });
    form1.setValue("idModelo", data.idModelo, { shouldValidate: true });
    form1.setValue("idArea", data.idArea, { shouldValidate: true });
    form1.setValue("idLocal", data.idLocal, { shouldValidate: true });
    form1.setValue("idTPServicio", data.idTPServicio, { shouldValidate: true });

    const modal = new window.bootstrap.Modal(modalRef.current);
    modal.show();
  };

  //CATEGORIA
  useEffect(() => {
    const fetchData = async () => {
      const response = await petitions.getCategoria(
        idEmpresa(),
        session().token,
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idCategoria,
          label: e.nombre,
        }));
        setCategoria(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchData();
  }, [form1, session, idEmpresa]);

  //MEDIDA
  useEffect(() => {
    const fetchMedida = async () => {
      const response = await petitions.getMedida(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMedida,
          label: `${e.idMedida} - ${e.descripcion}`,
        }));
        setMedida(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMedida();
  }, [form1, session, idEmpresa]);

  //AREA
  useEffect(() => {
    const fetchAreas = async () => {
      const obj = session();
      const response = await petitions.getAreas(idEmpresa(), obj.token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idArea,
          label: e.nomArea,
        }));
        setArea(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchAreas();
  }, [idEmpresa, session]);

  //LOCAL
  useEffect(() => {
    const fetchLocal = async () => {
      const obj = session();
      const response = await petitions.getLocal(idEmpresa(), obj.token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idLocal,
          label: e.nomLocal,
        }));
        setLocal(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchLocal();
  }, [idEmpresa, session]);

  //MARCA Y MODELO
  useEffect(() => {
    const fetchMarca = async () => {
      const response = await petitions.getMarca(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMarca,
          label: e.descripcion,
        }));
        setMarca(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMarca();
  }, [idEmpresa, session]);

  useEffect(() => {
    const fetchModeloMarca = async () => {
      const response = await petitions.getModeloMarca(
        idEmpresa(),
        session().token,
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setModelo(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchModeloMarca();
  }, [idEmpresa, session]);

  useEffect(() => {
    const fetchTPServicio = async () => {
      const response = await petitions.getTPServicio(
        idEmpresa(),
        session().token,
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idTPservicio,
          label: e.descripcion,
        }));
        setTPServicio(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPServicio();
  }, [idEmpresa, session]);

  const updateProducto = form1.handleSubmit(async (data) => {
    data.idPServicio = idProducto;
    data.kardex = data.kardex ? "S" : "N";
    data.dsct01 = data.dsct01 ? "S" : "N";

    const response = await petitions.updatePServicio(
      idEmpresa(),
      session().token,
      data,
    );
    if (response.status === "success") {
      if (response.data) {
        closeModal();
        toast.success("Producto actualizado correctamente");
        setEstadoTabla(!estadoTabla);
        form1.reset();
      } else {
        toast.warning("Ocurrió un problema, inténtelo mas tarde");
      }
    } else {
      closeModal();
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  const deleteProducto = (idPServicio) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estas seguro/a?",
        text: "No podrás cancelar el proceso",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const response = await petitions.deletePServicio(
            idEmpresa(),
            session().token,
            { idPServicio },
          );
          if (response.status === "success") {
            if (response.data) {
              setEstadoTabla(!estadoTabla);
              toast.success("Producto eliminado correctamente");
            } else {
              toast.warning("Ocurrió un problema, inténtelo mas tarde");
            }
          } else {
            var msg =
              typeof response.code === "string"
                ? response.message
                : response.data;
            toast.error(msg);
          }
        }
      });
  };

  const changeStatus = async (estado, idPServicio) => {
    estado = estado === "S" ? "N" : "S";
    const response = await petitions.UpdatePServicioStatus(
      idEmpresa(),
      session().token,
      { estado, idPServicio },
    );
    if (response.status === "success") {
      if (response.data) {
        setEstadoTabla(!estadoTabla);
        toast.message("Estado del producto actualizado correctamente", {
          description:
            "Recuerda que si el producto esta deshabilitado no se podrán hacer movimiento con el mismo.",
        });
      } else {
        toast.warning("Ocurrió un problema, inténtelo mas tarde");
      }
    } else {
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  };

  return (
    <>
      <div className="mb-9">
        <div className="row g-3 mb-1">
          <div className="col-auto">
            <h2 className="mb-0">Productos</h2>
          </div>
        </div>
        <ul className="nav nav-links mb-2 mb-lg-2 mx-n3">
          <li className="nav-item">
            <div className="nav-link active disabled" aria-current="page">
              <span>Todo</span>
              <span className="text-body-tertiary fw-semibold">
                ({productos.length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled">
              <span className="text-primary">Productos</span>
              <span className="text-body-tertiary fw-semibold">
                ({cantProducto.length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled">
              <span className="text-primary">Servicios</span>
              <span className="text-body-tertiary fw-semibold">
                ({cantServicio.length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled">
              <span className="text-primary">Paquetes</span>
              <span className="text-body-tertiary fw-semibold">
                ({cantPaquete.length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled">
              <span className="text-success">Habilitado</span>
              <span className="text-body-tertiary fw-semibold">
                ({habilitado.length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled">
              <span className="text-danger">Deshabilitado</span>
              <span className="text-body-tertiary fw-semibold">
                ({deshabilitado.length})
              </span>
            </div>
          </li>
        </ul>
        <div
          id="products"
          data-list='{"valueNames":["product","price","category","tags","vendor","time"],"page":10,"pagination":true}'
        >
          <div className="mb-4">
            <div className="d-flex flex-wrap gap-3">
              <div className="search-box">
                <input
                  className="form-control search-input search rounded-4 rounded-4 border-0 shadow-sm"
                  type="search"
                  placeholder="Buscar productos"
                  aria-label="Search"
                  value={filtering}
                  onChange={(e) => setFiltering(e.target.value)}
                />
                <span className="fas fa-search search-box-icon"></span>
              </div>
              <button
                className="btn px-3 btn-phoenix-secondary rounded-4"
                type="button"
                title="Filtros"
                onClick={() => {
                  const modal = new window.bootstrap.Modal(
                    modalRefFilter.current
                  );
                  modal.show();
                }}
              >
                {filtrosActivos ? "📌" : "⋮"}
              </button>
              <div className="ms-xxl-auto">
                <button
                  className="btn btn-link text-body me-4 px-0"
                  onClick={() =>
                    exportToExcel_v1(productos, columns, "Productos")
                  }
                >
                  <span className="fa-solid fa-file-export fs-9 me-2"></span>
                  Exportar
                </button>
              </div>

              <div className="ms-xxl-auto">
                <NavLink
                  className="btn btn-primary me-3 rounded-4"
                  to={"/main/CrearProducto"}
                >
                  <span className="fas fa-plus me-2"></span>Agregar producto
                </NavLink>
                <NavLink
                  className="btn btn-subtle-info pointer-events-none rounded-4"
                  to={"/main/importproductos"}
                >
                  <span className="fas fa-upload me-2"></span>Importar productos
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          {load ? (
            <TableLoad />
          ) : (
            <Table
              data={productos}
              columns={columns}
              filtering={filtering}
              setFiltering={setFiltering}
              channel={channel}
              deleteProducto={deleteProducto}
              changeStatus={changeStatus}
            />
          )}
        </div>
      </div>
      <div
        className="modal fade bd-example-modal-lg"
        id="modalEditar"
        tabIndex="-1"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-primary">
              <h5
                className="modal-title text-white dark__text-gray-1100"
                id="staticBackdropLabel"
              >
                Editar producto
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9 text-white dark__text-gray-1100"></span>
              </button>
            </div>
            <form onSubmit={updateProducto}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-4 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Titulo
                    </label>
                    <input
                      className="form-control rounded-4"
                      type="text"
                      {...form1.register("nombre", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                        maxLength: {
                          value: 250,
                          message: "Nombre demasiado largo",
                        },
                      })}
                    />
                  </div>
                  <div className="col-5 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Descripción
                    </label>
                    <input
                      className="form-control rounded-4"
                      type="text"
                      {...form1.register("obs", {
                        maxLength: {
                          value: 254,
                          message: "Descripción demasiada larga",
                        },
                      })}
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Tipo de item
                    </label>
                    <Select
                      className="mb-0 mi-select mi-select-bordered"
                      classNamePrefix="rs"
                      options={tipo}
                      styles={customStyles}
                      value={
                        tipo.find(
                          (option) => option.value === form1.watch("tipo"),
                        ) || null
                      }
                      {...form1.register("tipo", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                      onChange={(event) => {
                        form1.setValue("tipo", event.value, {
                          shouldValidate: true,
                        });
                      }}
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Precio compra
                    </label>
                    <input
                      className="form-control rounded-4"
                      type="number"
                      step="any"
                      {...form1.register("pcompra")}
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Precio venta
                    </label>
                    <input
                      className="form-control rounded-4"
                      type="number"
                      step="any"
                      {...form1.register("pventa")}
                    />
                  </div>
                  <div className="col-6 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Tiempo de garantia
                    </label>
                    <input
                      className="form-control rounded-4"
                      type="text"
                      {...form1.register("tGarantia", {
                        maxLength: {
                          value: 64,
                          message: "Descripción demasiada larga",
                        },
                      })}
                    />
                  </div>
                  <div className="col-2 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Stock
                    </label>
                    <input
                      className="form-control rounded-4"
                      type="number"
                      step="any"
                      {...form1.register("stock")}
                    />
                  </div>
                  <div className="col-4 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Clasificación de producto
                    </label>
                    <Select
                      className="mb-0 mi-select mi-select-bordered"
                      classNamePrefix="rs"
                      options={TPServicio}
                      styles={customStyles}
                      value={
                        TPServicio.find(
                          (option) =>
                            option.value === form1.watch("idTPServicio"),
                        ) || null
                      }
                      {...form1.register("idTPServicio", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                      onChange={(event) => {
                        form1.setValue("idTPServicio", event.value);
                      }}
                    />
                  </div>
                  <div className="col-3 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Ciclo de consumo
                    </label>
                    <input
                      className="form-control rounded-4"
                      type="number"
                      step="any"
                      {...form1.register("cicloConsumo")}
                    />
                  </div>
                  <div className="col-3 mb-3 mt-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        {...form1.register("kardex")}
                      />
                      <label
                        className="form-check-label text-body fs-9"
                        htmlFor="fragileCheck"
                      >
                        Kardex
                      </label>
                    </div>
                  </div>
                  <div className="col-3 mb-3 mt-4 m-5">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        {...form1.register("dsct01")}
                      />
                      <label
                        className="form-check-label text-body fs-9"
                        htmlFor="fragileCheck"
                      >
                        Editar descuento
                      </label>
                    </div>
                  </div>
                  <div className="col-4 mb-4">
                    <label className="form-label" htmlFor="validationCustom01">
                      Descuento
                    </label>
                    <input
                      className="form-control rounded-4"
                      type="number"
                      step="any"
                      {...form1.register("dsct02")}
                    />
                  </div>
                  <hr />
                </div>
                <div className="row">
                  <div className="col-4 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Categoria
                    </label>
                    <Select
                      className="mb-0 mi-select mi-select-bordered"
                      classNamePrefix="rs"
                      options={categoria}
                      styles={customStyles}
                      value={
                        categoria.find(
                          (option) =>
                            option.value === form1.watch("idCategoria"),
                        ) || null
                      }
                      {...form1.register("idCategoria", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                      onChange={(event) => {
                        form1.setValue("idCategoria", event.value, {
                          shouldValidate: true,
                        });
                      }}
                    />
                  </div>
                  <div className="col-4 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Medida
                    </label>
                    <Select
                      className="mb-0 mi-select mi-select-bordered"
                      classNamePrefix="rs"
                      options={medida}
                      styles={customStyles}
                      value={
                        medida.find(
                          (option) => option.value === form1.watch("idMedida"),
                        ) || null
                      }
                      {...form1.register("idMedida", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                      onChange={(event) => {
                        form1.setValue("idMedida", event.value);
                      }}
                    />
                  </div>
                  <div className="col-4 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Marca
                    </label>
                    <Select
                      className="mb-0 mi-select mi-select-bordered"
                      classNamePrefix="rs"
                      options={marca}
                      styles={customStyles}
                      value={
                        marca.find(
                          (option) => option.value === form1.watch("idMarca"),
                        ) || null
                      }
                      {...form1.register("idMarca", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                      onChange={(event) => {
                        form1.setValue("idMarca", event.value);
                      }}
                    />
                  </div>
                  <div className="col-4 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Modelo
                    </label>
                    <Select
                      className="mb-0 mi-select mi-select-bordered"
                      classNamePrefix="rs"
                      options={modelo}
                      styles={customStyles}
                      value={
                        modelo.find(
                          (option) => option.value === form1.watch("idModelo"),
                        ) || null
                      }
                      {...form1.register("idModelo", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                      onChange={(event) => {
                        form1.setValue("idModelo", event.value);
                      }}
                    />
                  </div>
                  <div className="col-4 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Área
                    </label>
                    <Select
                      className="mb-0 mi-select mi-select-bordered"
                      classNamePrefix="rs"
                      options={area}
                      styles={customStyles}
                      value={
                        area.find(
                          (option) => option.value === form1.watch("idArea"),
                        ) || null
                      }
                      {...form1.register("idArea", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                      onChange={(event) => {
                        form1.setValue("idArea", event.value);
                      }}
                    />
                  </div>
                  <div className="col-4 mb-3">
                    <label className="form-label" htmlFor="validationCustom01">
                      Local
                    </label>
                    <Select
                      className="mb-0 mi-select mi-select-bordered"
                      classNamePrefix="rs"
                      options={local}
                      styles={customStyles}
                      value={
                        local.find(
                          (option) => option.value === form1.watch("idLocal"),
                        ) || null
                      }
                      {...form1.register("idLocal", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                      onChange={(event) => {
                        form1.setValue("idLocal", event.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary rounded-4 rounded-4"
                  type="submit"
                >
                  Actualizar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="reportsFilterModal"
        tabIndex="-1"
        ref={modalRefFilter}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border border-translucent rounded-4">
            <form autoComplete="off" onSubmit={aplicarFiltros}>
              <div className="modal-header border-translucent p-4">
                <h5 className="modal-title text-body-highlight fs-6 lh-sm">
                  Filtros
                </h5>
                <button
                  className="btn p-1 text-danger"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>

              <div className="modal-body pt-4 pb-2 px-4">
                <div className="mb-3">
                  <label className="fw-bold mb-2 text-body-highlight">
                    Tipo
                  </label>

                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    styles={customStyles}
                    options={[{ value: "", label: "Todos" }, ...tipo]}
                    value={
                      [{ value: "", label: "Todos" }, ...tipo].find(
                        (option) => option.value === form2.watch("tipo"),
                      ) || null
                    }
                    onChange={(event) => {
                      form2.setValue("tipo", event?.value ?? "");
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label className="fw-bold mb-2 text-body-highlight">
                    Categoría
                  </label>

                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    styles={customStyles}
                    options={[{ value: 0, label: "Todas" }, ...categoria]}
                    value={
                      [{ value: "", label: "Todas" }, ...categoria].find(
                        (option) => option.value === form2.watch("idCategoria"),
                      ) || null
                    }
                    onChange={(event) => {
                      form2.setValue("idCategoria", event?.value ?? "");
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label className="fw-bold mb-2 text-body-highlight">
                    Clasificación
                  </label>

                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    styles={customStyles}
                    options={[{ value: "", label: "Todas" }, ...TPServicio]}
                    value={
                      [{ value: "", label: "Todas" }, ...TPServicio].find(
                        (option) =>
                          option.value === form2.watch("idTPServicio"),
                      ) || null
                    }
                    onChange={(event) => {
                      form2.setValue("idTPServicio", event?.value ?? "");
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label className="fw-bold mb-2 text-body-highlight">
                    Estado
                  </label>

                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    styles={customStyles}
                    options={[
                      { value: "", label: "Todos" },
                      { value: "S", label: "Habilitado" },
                      { value: "N", label: "Deshabilitado" },
                    ]}
                    value={
                      [
                        { value: "", label: "Todos" },
                        { value: "S", label: "Habilitado" },
                        { value: "N", label: "Deshabilitado" },
                      ].find(
                        (option) => option.value === form2.watch("estado"),
                      ) || null
                    }
                    onChange={(event) => {
                      form2.setValue("estado", event?.value ?? "");
                    }}
                  />
                </div>
              </div>

              <div className="modal-footer d-flex justify-content-end align-items-center px-4 pb-4 border-0 pt-3">
                <button
                  className="btn btn-sm btn-phoenix-primary px-4 fs-10 my-0 rounded-4"
                  type="button"
                  onClick={() => form2.reset()}
                >
                  <span className="fas fa-arrows-rotate me-2 fs-10"></span>
                  Reiniciar
                </button>

                <button
                  className="btn btn-sm btn-primary px-9 fs-10 my-0 rounded-4"
                  type="submit"
                >
                  Hecho
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
